import { render } from "./SelectorAgeCategories.vue?vue&type=template&id=03318408&scoped=true"
import script from "./SelectorAgeCategories.vue?vue&type=script&lang=js"
export * from "./SelectorAgeCategories.vue?vue&type=script&lang=js"

import "./SelectorAgeCategories.vue?vue&type=style&index=0&id=03318408&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03318408"]])

export default __exports__